export const eko = {
    namespaced: true,
    state: {
        status: '0'
    },
    mutations: {
        UPDATE_STATUS(state, value) {
            state.status = value
        }
    },
    actions: {
        changeStatus({ state, commit }) {
            const status = state.status === '0' ? '1' : '0'
            commit('UPDATE_STATUS', status)
            this.$storage.setItem('ekoStatus', status)
        },
        fetchFromStorage({ commit }) {
            this.$storage.getItem('ekoStatus').then(value => {
                commit('UPDATE_STATUS', typeof value === 'string' ? value : '0')
            })
        }
    },
    getters: {
        status: state => state.status
    }
}
